import React, { FC } from "react";
import { InputGroup } from "@asd-stan/user/components/layout/input-group/input-group";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import {
    StandardDisplayContainer,
    StandardDisplayField,
    StandardDisplayFieldHeader,
    StandardDisplayFieldValue, StandardDisplayFieldValueAbsent,
    StandardDisplayRow
} from "../../single-standard.styled";
import { SingleStandardField } from "../../single-standard-field";
import { ProjectLeader } from "@asd-stan/standard/components/general/project-leader/project-leader";
import { CreatedBy, Leader } from "@asd-stan/standard/domain/standard-detailed.entity";

interface Props {
    createdAt: string;
    updatedAt: string;
    createdBy: CreatedBy | null;
}

export const RegistrationData: FC<Props> = (props) => {
    const { t } = useTranslation();
    const createdAt = DateTime.fromISO(props.createdAt).toFormat('dd/LL/yyyy hh:mm');
    const updatedAt = DateTime.fromISO(props.updatedAt).toFormat('dd/LL/yyyy hh:mm');

    return (
        <InputGroup title={t('standard.singleStandardPage.regData.title')}>
            <StandardDisplayContainer>
                <StandardDisplayRow>
                    <SingleStandardField
                        header={t('standard.singleStandardPage.regData.createdAt')}
                        value={createdAt}
                    />
                    <SingleStandardField
                        header={t('standard.singleStandardPage.regData.updatedAt')}
                        value={updatedAt}
                    />
                </StandardDisplayRow>
                <StandardDisplayRow>
                    <StandardDisplayField>
                        <StandardDisplayFieldHeader>
                            {t('standard.singleStandardPage.regData.createdBy')}{' '}
                            {!!props.createdBy?.deletedAt}
                        </StandardDisplayFieldHeader>
                        {props.createdBy ? (
                            <StandardDisplayFieldValue>
                                <ProjectLeader user={props.createdBy}/>
                            </StandardDisplayFieldValue>
                        ) : (
                            <StandardDisplayFieldValueAbsent>
                                {t('standard.singleStandardPage.regData.createdByAbsent')}
                            </StandardDisplayFieldValueAbsent>
                        )}
                    </StandardDisplayField>
                </StandardDisplayRow>
            </StandardDisplayContainer>

        </InputGroup>
    )
}